import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export const SmallClaimLimitCard = ({ isAdmin }) => {
  const [limit, setLimit] = useState("");
  useEffect(() => { api.get("/v2/settings/approval-chain").then(r => setLimit(String(r.data.small_claim_limit))); }, []);
  const save = async () => {
    try { await api.put("/v2/settings/approval-chain", { small_claim_limit: Number(limit) }); toast.success("Small-claim limit saved"); }
    catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
  };
  return (
    <Card className="mb-4" data-testid="small-claim-card"><CardContent className="p-5 flex flex-wrap items-end gap-3">
      <div>
        <div className="text-sm font-semibold">Small-claim limit (₹)</div>
        <p className="text-xs text-slate-500">Reimbursements and advances below this are final at Accounts Verify (Super Admin's own claims always go to the Trustee Approver).</p>
        <Input type="number" min="0" className="mt-2 w-40" value={limit} onChange={e => setLimit(e.target.value)} disabled={!isAdmin} data-testid="small-claim-input" />
      </div>
      {isAdmin && <Button onClick={save} data-testid="small-claim-save">Save</Button>}
    </CardContent></Card>
  );
};
